/* eslint-disable @calm/react-intl/missing-formatted-message */

import FullscreenBackground from '@/components/image/FullscreenBackground';
import GridWrapper from '@/components/ui/GridWrapper';

import { JaySectionProps } from '../JayLandingPageLayout/types';
import { ButtonWrapper, Heading, JayHeadshot, Logo, StyledButton, Wrapper } from './styles';

const Hero = ({ onCtaClick, isTrialFlow }: JaySectionProps) => {
	const buttonCopy = isTrialFlow ? 'Start Free Trial' : 'Get 40% Off Calm';

	return (
		<Wrapper>
			<FullscreenBackground src="/_n/images/jayshetty/jay-hero-bg.webp" />
			<GridWrapper columns={2}>
				<div>
					<Logo />
					<Heading>Calm your mind, change your life.</Heading>
					<ButtonWrapper>
						<StyledButton
							fullWidth
							backgroundColor="white"
							textColor="gray8"
							onPress={() => {
								onCtaClick({
									section: 'header',
									copy: buttonCopy,
									pos: 1,
								});
							}}
						>
							{buttonCopy}
						</StyledButton>
					</ButtonWrapper>
				</div>
			</GridWrapper>
			<JayHeadshot src="/_n/images/jayshetty/jay-portrait.webp" alt="Jay Shetty" />
		</Wrapper>
	);
};

export default Hero;
